module.exports = __webpack_public_path__ + "static/media/pic1.e28617c0.jpg";